import React from 'react';
import { Handle, Position } from 'reactflow';
import { Image } from 'lucide-react';

const VisualNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-green-200 node-visual">
      <div className="flex items-center">
        <Image className="w-4 h-4 text-green-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-green-800">Visual Generator</div>
          <div className="text-sm text-gray-600">
            {data.config?.concept || 'Create educational visuals'}
          </div>
          <div className="text-xs text-green-600">
            Style: {data.config?.style || 'educational'}
          </div>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Top}
        id="input"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-green-500 border-2 border-white"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-green-500 border-2 border-white"
      />
    </div>
  );
};

export default VisualNode;